import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id AECECEA4-9E56-4B4B-ACD6-2C85AB09788A
 * name filter-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-variant.svg
 * tags
 */
export const FilterVariantIcon = createSvgIcon(<><path d="M6,13H18V11H6M3,6V8H21V6M10,18H14V16H10V18Z" /></>, 'FilterVariantIcon');
export default FilterVariantIcon